export default __webpack_public_path__ + "static/media/hosting.02958745.svg";